import { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { UserDto } from '../../dtos';
import { ApiError, LoadingIndicator, useFailedUpdateSnackbar, useSuccessfulUpdateSnackbar } from '../../Components/CoreLib/library';
import { useGetUserByIdQuery, useUpdateUserMutation } from '../../store/generated/generatedApi';
import { UserForm } from '../../Components/Forms/UserForm';

export const EditUserView: FC = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { data, isLoading, error, refetch } = useGetUserByIdQuery({ id: id! });
    const [updateUser, { isSuccess, isError, reset, error: updateError}] = useUpdateUserMutation();

    useSuccessfulUpdateSnackbar('User', isSuccess, reset);
    useFailedUpdateSnackbar('user', isError, reset, updateError);

    const handleSave = (values: UserDto) => {
        updateUser(values);
    };

    const handleCancel = () => {
        navigate('/users');
    };

    if (isLoading) {
        return <LoadingIndicator />;
    }

    if (error) {
        return <ApiError onReloadClick={refetch} />;
    }

    return <UserForm save={handleSave} cancel={handleCancel} initValues={data} />;
};
